class ScrollAnimations {
    constructor() {
        this.elements = document.querySelectorAll('.animate-on-scroll');
        this.options = {
            root: null,
            rootMargin: '0px 0px -10% 0px', // Trigger when 10% from bottom
            threshold: 0.1 // Trigger when 10% visible
        };

        this.init();
    }

    init() {
        // Check if user prefers reduced motion
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (prefersReducedMotion || this.elements.length === 0) {
            if (prefersReducedMotion) {
                this.elements.forEach(el => el.classList.add('is-visible'));
            }
            return;
        }

        this.observer = new IntersectionObserver(this.handleIntersect.bind(this), this.options);

        this.elements.forEach(el => {
            this.observer.observe(el);
        });
    }

    handleIntersect(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Add the class to trigger the CSS animation
                entry.target.classList.add('is-visible');

                // Stop observing once it's animated to keep it visible
                observer.unobserve(entry.target);
            }
        });
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    new ScrollAnimations();
});

// Re-initialize for Shopify Theme Editor events
document.addEventListener('shopify:section:load', () => {
    new ScrollAnimations();
});
